import { Button, styled } from "@mui/material";

const OutlinedSelectButton = styled(Button)(({ theme }) => ({
  height: 40,
  border: "1px solid",
  borderColor:
    theme.palette.mode === "light"
      ? "rgba(0, 0, 0, 0.23)"
      : "rgba(255, 255, 255, 0.23)",
  borderRadius: theme.shape.borderRadius,
  padding: "8px 16px",
  textTransform: "none",
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.secondary,
  whiteSpace: "nowrap",
  "&:hover": {
    borderColor: theme.palette.text.primary,
    backgroundColor: "transparent",
  },
  "&:focus": {
    borderColor: theme.palette.primary.main,
  },
}));

export default OutlinedSelectButton;
